import { useEffect as t, useCallback as r } from "react";
import e from "dayjs";
import { useNavigate as a, useParams as o } from "react-router-dom";
import { ISO_DATE_FORMAT as m } from "../utils/formatDate.js";
const p = (p2) => {
  const i = a(), { date: d, year: f } = o(), c = d ?? f, n = e().add(-1, "day").format(m), s = p2 ?? n, u = c ?? s;
  t(() => {
    c || i(`../${s}`, { relative: "path", replace: true });
  }, [c, s, i]);
  return { routeDate: u, onChangeRouteDate: r((t2) => {
    t2 && t2 !== c && i(`../${t2}`, { relative: "path" });
  }, [i, c]) };
};
export {
  p as useChangeRouteDate
};
//# sourceMappingURL=useChangeRouteDate.js.map
